import { Link } from "react-router";
import type { Post, PostImage } from "@abejon/shared";

interface PostCardProps {
  post: Post & { images: PostImage[] };
}

export function PostCard({ post }: PostCardProps) {
  const thumbnail = post.images[0];
  const hasMultiple = post.images.length > 1;

  return (
    <Link
      to={`/posts/${post.id}`}
      aria-label={post.caption ? `Post: ${post.caption.slice(0, 50)}` : "View post"}
      className="relative block aspect-square overflow-hidden rounded-sm bg-gray-100 focus-visible:ring-2 focus-visible:ring-gray-900 focus-visible:ring-offset-2"
    >
      {thumbnail ? (
        <img
          src={thumbnail.imageUrl}
          alt={post.caption ?? ""}
          className="h-full w-full object-cover transition-opacity hover:opacity-90"
          loading="lazy"
        />
      ) : (
        <div className="flex h-full items-center justify-center text-gray-400">
          No image
        </div>
      )}

      {/* Multi-image indicator */}
      {hasMultiple && (
        <div className="absolute top-2 right-2 rounded bg-black/60 px-1.5 py-0.5 text-xs font-medium text-white">
          {post.images.length}
        </div>
      )}
    </Link>
  );
}
